// Mock data for BMPS website - English & Indonesian content

export const translations = {
  en: {
    nav: {
      home: 'Home',
      whyUs: 'Why Choose Us',
      team: 'Our Team',
      clients: 'Clients',
      activities: 'Activities',
      contact: 'Contact',
      joinUs: 'Join Us'
    },
    hero: {
      title: 'Transform Plastic Waste into Economic Value with BMPS',
      subtitle: 'Together, we create a cleaner, greener, and sustainable future.',
      ctaPrimary: 'Join Us',
      ctaSecondary: 'See How It Works'
    },
    stats: {
      customers: '2,350+',
      customersLabel: 'Customers',
      officers: '48',
      officersLabel: 'Officers',
      recycled: '186,000',
      recycledLabel: 'kg Plastic Recycled'
    },
    about: {
      title: 'About BMPS',
      description: 'BMPS is your trusted partner in providing high-quality recycled PET bottle materials for the plastic processing industry. We ensure strict sorting, stable supply, and transparent distribution.'
    },
    vision: {
      title: 'Our Vision',
      text: 'Transform Plastic Waste into Economic Value and Support a Plastic-Free Indonesia.'
    },
    mission: {
      title: 'Our Mission',
      items: [
        'Provide consistent, premium recycled PET materials',
        'Empower partners and improve community welfare',
        'Actively reduce plastic waste nationwide'
      ]
    },
    cta: {
      title: 'Join the Eco Movement',
      subtitle: 'Partner with us to create a sustainable future',
      btnPartner: 'Become Our Partner',
      btnLearn: 'Learn More'
    },
    whyChoose: {
      title: 'Why Choose PT. Berkah Mitra Perdana Sukses',
      subtitle: 'Trusted, Transparent, and Committed to a Greener Future.',
      reasons: [
        {
          title: 'Strict Sorting Standards',
          description: 'Every recycled PET meets premium quality through rigorous sorting and inspection processes.'
        },
        {
          title: 'Stable Supply Chain',
          description: 'Reliable delivery and consistent flow ensuring your production never stops.'
        },
        {
          title: 'Transparent Operations',
          description: 'Clear and traceable recycling process from collection to delivery.'
        },
        {
          title: 'Community Empowerment',
          description: 'Supporting local collectors and creating sustainable jobs in communities.'
        },
        {
          title: 'Eco Commitment',
          description: 'Active contribution to plastic waste reduction and environmental protection.'
        },
        {
          title: 'Proven Partnerships',
          description: 'Trusted by national recycling programs and leading manufacturers.'
        }
      ]
    },
    team: {
      title: 'Our Team',
      subtitle: 'Meet the people driving sustainable innovation at BMPS',
      members: [
        {
          name: 'Junaedi',
          role: 'CEO',
          description: 'Visionary leader focused on sustainable innovation and building strategic partnerships.'
        },
        {
          name: 'Anisa',
          role: 'Head of Operations',
          description: 'Oversees efficient recycling workflows and ensures quality standards are maintained.'
        },
        {
          name: 'Sindy',
          role: 'Finance Manager',
          description: 'Ensures financial transparency and sustainable eco-focused budgeting practices.'
        },
        {
          name: 'Nurhidayati',
          role: 'HR & Community',
          description: 'Builds partnerships and empowers local workers for community development.'
        },
        {
          name: 'Anas Hanurawan',
          role: 'Production Supervisor',
          description: 'Maintains strict PET quality standards and optimizes production efficiency.'
        },
        {
          name: 'Rio Andri Astiko',
          role: 'Logistics & Supply',
          description: 'Manages transparent distribution and ensures timely delivery to partners.'
        }
      ]
    },
    clients: {
      title: 'Our Clients & Partners',
      subtitle: 'Trusted by recycling industries and eco-conscious communities.',
      partners: [
        { name: 'EcoRecycle Indonesia', industry: 'Recycling & Processing' },
        { name: 'GreenLoop Industries', industry: 'Sustainable Manufacturing' },
        { name: 'Nusantara Plastic Processing', industry: 'PET Processing' },
        { name: 'GoGreen Initiative', industry: 'Environmental Organization' },
        { name: 'OceanCare Foundation', industry: 'Marine Conservation' },
        { name: 'PlasticFree Alliance', industry: 'Advocacy Group' }
      ],
      testimonials: [
        {
          name: 'Ahmad Santoso',
          organization: 'EcoRecycle Indonesia',
          role: 'Operations Director',
          feedback: 'BMPS has been our reliable partner for 3 years. Their consistent quality and transparent processes make them stand out in the industry.'
        },
        {
          name: 'Sarah Wijaya',
          organization: 'GreenLoop Industries',
          role: 'Sustainability Manager',
          feedback: 'Working with BMPS helped us achieve our sustainability goals. Their commitment to quality recycled materials is unmatched.'
        },
        {
          name: 'Budi Prasetyo',
          organization: 'Nusantara Plastic Processing',
          role: 'CEO',
          feedback: 'The stable supply chain and premium PET quality from BMPS have been crucial to our production efficiency.'
        }
      ]
    },
    activities: {
      title: 'Our Activities & Community Impact',
      subtitle: 'Together, we inspire change through action.',
      events: [
        {
          title: 'Beach Cleanup Day',
          date: 'January 15, 2025',
          description: 'BMPS volunteers cleaned 3 km of coastline, collecting over 1,200 kg of plastic waste and raising awareness about ocean pollution.',
          category: 'Environmental'
        },
        {
          title: 'Recycling Education Workshop',
          date: 'February 8, 2025',
          description: 'Educational outreach in local schools about the importance of PET recycling and proper waste management practices.',
          category: 'Education'
        },
        {
          title: 'Community Waste Sorting Program',
          date: 'March 12, 2025',
          description: 'Training sessions for residents on waste sorting and recycling best practices, reaching over 500 households.',
          category: 'Community'
        },
        {
          title: 'Partnership with Local Collectors',
          date: 'April 5, 2025',
          description: 'Empowering 100+ waste collectors with training, equipment, and fair compensation for quality PET collection.',
          category: 'Partnership'
        },
        {
          title: 'Plastic-Free Campaign 2025',
          date: 'May 20, 2025',
          description: 'Month-long campaign promoting plastic waste reduction and sustainable alternatives in partnership with local businesses.',
          category: 'Advocacy'
        },
        {
          title: 'Green Innovation Summit',
          date: 'June 18, 2025',
          description: 'Hosting industry leaders to discuss innovations in recycling technology and circular economy practices.',
          category: 'Conference'
        }
      ]
    },
    footer: {
      company: 'PT. Berkah Mitra Perdana Sukses',
      tagline: 'Transforming Plastic Waste into Economic Value',
      rights: '© 2025 BMPS. All rights reserved.',
      address: 'Jakarta, Indonesia'
    }
  },
  id: {
    nav: {
      home: 'Beranda',
      whyUs: 'Mengapa Kami',
      team: 'Tim Kami',
      clients: 'Klien Kami',
      activities: 'Info Kegiatan',
      contact: 'Kontak',
      joinUs: 'Bergabung'
    },
    hero: {
      title: 'Ubah Sampah Plastik Menjadi Nilai Ekonomi dengan BMPS',
      subtitle: 'Bersama, kita ciptakan masa depan yang lebih bersih, hijau, dan berkelanjutan.',
      ctaPrimary: 'Bergabung',
      ctaSecondary: 'Lihat Cara Kerja'
    },
    stats: {
      customers: '2.350+',
      customersLabel: 'Pelanggan',
      officers: '48',
      officersLabel: 'Petugas',
      recycled: '186.000',
      recycledLabel: 'kg Plastik Didaur Ulang'
    },
    about: {
      title: 'Tentang BMPS',
      description: 'BMPS adalah mitra terpercaya Anda dalam menyediakan bahan botol PET daur ulang berkualitas tinggi untuk industri pengolahan plastik. Kami memastikan penyortiran ketat, pasokan stabil, dan distribusi transparan.'
    },
    vision: {
      title: 'Visi Kami',
      text: 'Mengubah Sampah Plastik Menjadi Nilai Ekonomi dan Mendukung Indonesia Bebas Plastik.'
    },
    mission: {
      title: 'Misi Kami',
      items: [
        'Menyediakan bahan PET daur ulang premium yang konsisten',
        'Memberdayakan mitra dan meningkatkan kesejahteraan masyarakat',
        'Aktif mengurangi sampah plastik di seluruh Indonesia'
      ]
    },
    cta: {
      title: 'Bergabung dengan Gerakan Ramah Lingkungan',
      subtitle: 'Bermitra dengan kami untuk menciptakan masa depan berkelanjutan',
      btnPartner: 'Menjadi Mitra Kami',
      btnLearn: 'Pelajari Lebih Lanjut'
    },
    whyChoose: {
      title: 'Mengapa Memilih PT. Berkah Mitra Perdana Sukses',
      subtitle: 'Terpercaya, Transparan, dan Berkomitmen untuk Masa Depan Lebih Hijau.',
      reasons: [
        {
          title: 'Standar Penyortiran Ketat',
          description: 'Setiap PET daur ulang memenuhi kualitas premium melalui proses penyortiran dan inspeksi yang ketat.'
        },
        {
          title: 'Rantai Pasokan Stabil',
          description: 'Pengiriman andal dan aliran konsisten memastikan produksi Anda tidak pernah berhenti.'
        },
        {
          title: 'Operasi Transparan',
          description: 'Proses daur ulang yang jelas dan dapat dilacak dari pengumpulan hingga pengiriman.'
        },
        {
          title: 'Pemberdayaan Masyarakat',
          description: 'Mendukung pengumpul lokal dan menciptakan pekerjaan berkelanjutan di komunitas.'
        },
        {
          title: 'Komitmen Ramah Lingkungan',
          description: 'Kontribusi aktif untuk pengurangan sampah plastik dan perlindungan lingkungan.'
        },
        {
          title: 'Kemitraan Terbukti',
          description: 'Dipercaya oleh program daur ulang nasional dan produsen terkemuka.'
        }
      ]
    },
    team: {
      title: 'Tim Kami',
      subtitle: 'Kenali orang-orang yang mendorong inovasi berkelanjutan di BMPS',
      members: [
        {
          name: 'Junaedi',
          role: 'CEO',
          description: 'Pemimpin visioner yang fokus pada inovasi berkelanjutan dan membangun kemitraan strategis.'
        },
        {
          name: 'Anisa',
          role: 'Kepala Operasi',
          description: 'Mengawasi alur kerja daur ulang yang efisien dan memastikan standar kualitas terjaga.'
        },
        {
          name: 'Sindy',
          role: 'Manajer Keuangan',
          description: 'Memastikan transparansi keuangan dan praktik penganggaran ramah lingkungan yang berkelanjutan.'
        },
        {
          name: 'Nurhidayati',
          role: 'SDM & Komunitas',
          description: 'Membangun kemitraan dan memberdayakan pekerja lokal untuk pengembangan komunitas.'
        },
        {
          name: 'Anas Hanurawan',
          role: 'Supervisor Produksi',
          description: 'Memelihara standar kualitas PET yang ketat dan mengoptimalkan efisiensi produksi.'
        },
        {
          name: 'Rio Andri Astiko',
          role: 'Logistik & Pasokan',
          description: 'Mengelola distribusi transparan dan memastikan pengiriman tepat waktu ke mitra.'
        }
      ]
    },
    clients: {
      title: 'Klien & Mitra Kami',
      subtitle: 'Dipercaya oleh industri daur ulang dan komunitas peduli lingkungan.',
      partners: [
        { name: 'EcoRecycle Indonesia', industry: 'Daur Ulang & Pengolahan' },
        { name: 'GreenLoop Industries', industry: 'Manufaktur Berkelanjutan' },
        { name: 'Nusantara Plastic Processing', industry: 'Pengolahan PET' },
        { name: 'GoGreen Initiative', industry: 'Organisasi Lingkungan' },
        { name: 'OceanCare Foundation', industry: 'Konservasi Laut' },
        { name: 'PlasticFree Alliance', industry: 'Kelompok Advokasi' }
      ],
      testimonials: [
        {
          name: 'Ahmad Santoso',
          organization: 'EcoRecycle Indonesia',
          role: 'Direktur Operasi',
          feedback: 'BMPS telah menjadi mitra andal kami selama 3 tahun. Kualitas konsisten dan proses transparan mereka membuat mereka menonjol di industri ini.'
        },
        {
          name: 'Sarah Wijaya',
          organization: 'GreenLoop Industries',
          role: 'Manajer Keberlanjutan',
          feedback: 'Bekerja sama dengan BMPS membantu kami mencapai tujuan keberlanjutan. Komitmen mereka terhadap bahan daur ulang berkualitas tidak tertandingi.'
        },
        {
          name: 'Budi Prasetyo',
          organization: 'Nusantara Plastic Processing',
          role: 'CEO',
          feedback: 'Rantai pasokan stabil dan kualitas PET premium dari BMPS sangat penting bagi efisiensi produksi kami.'
        }
      ]
    },
    activities: {
      title: 'Kegiatan & Dampak Komunitas Kami',
      subtitle: 'Bersama, kami menginspirasi perubahan melalui tindakan.',
      events: [
        {
          title: 'Hari Bersih-Bersih Pantai',
          date: '15 Januari 2025',
          description: 'Relawan BMPS membersihkan 3 km garis pantai, mengumpulkan lebih dari 1.200 kg sampah plastik dan meningkatkan kesadaran tentang polusi laut.',
          category: 'Lingkungan'
        },
        {
          title: 'Workshop Pendidikan Daur Ulang',
          date: '8 Februari 2025',
          description: 'Penyuluhan pendidikan di sekolah-sekolah lokal tentang pentingnya daur ulang PET dan praktik pengelolaan sampah yang tepat.',
          category: 'Pendidikan'
        },
        {
          title: 'Program Pemilahan Sampah Komunitas',
          date: '12 Maret 2025',
          description: 'Sesi pelatihan untuk warga tentang pemilahan sampah dan praktik daur ulang terbaik, menjangkau lebih dari 500 rumah tangga.',
          category: 'Komunitas'
        },
        {
          title: 'Kemitraan dengan Pengumpul Lokal',
          date: '5 April 2025',
          description: 'Memberdayakan 100+ pengumpul sampah dengan pelatihan, peralatan, dan kompensasi yang adil untuk pengumpulan PET berkualitas.',
          category: 'Kemitraan'
        },
        {
          title: 'Kampanye Bebas Plastik 2025',
          date: '20 Mei 2025',
          description: 'Kampanye selama sebulan yang mempromosikan pengurangan sampah plastik dan alternatif berkelanjutan bermitra dengan bisnis lokal.',
          category: 'Advokasi'
        },
        {
          title: 'Green Innovation Summit',
          date: '18 Juni 2025',
          description: 'Mengadakan acara untuk pemimpin industri membahas inovasi dalam teknologi daur ulang dan praktik ekonomi sirkular.',
          category: 'Konferensi'
        }
      ]
    },
    footer: {
      company: 'PT. Berkah Mitra Perdana Sukses',
      tagline: 'Mengubah Sampah Plastik Menjadi Nilai Ekonomi',
      rights: '© 2025 BMPS. Hak cipta dilindungi.',
      address: 'Jakarta, Indonesia'
    }
  }
};

// Language management
export const getTranslation = (lang = 'en') => {
  return translations[lang] || translations.en;
};